import React, { useState } from 'react';
import axios from 'axios';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box, Card, CardContent, TextField, Button, Typography, Alert,
  Stack, InputAdornment, Link, CircularProgress,
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [feedback, setFeedback] = useState(null); // { type: 'success'|'error', text }
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback(null);
    setLoading(true);
    try {
      await axios.post('https://portal.peaksoftcon.com:8081/forgotPassword', { email });
      setFeedback({
        type: 'success',
        text: 'Bu e-postaya bağlı bir hesap varsa, sıfırlama bağlantısı gönderildi.',
      });
    } catch (err) {
      setFeedback({ type: 'error', text: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: (t) =>
          t.palette.mode === 'dark'
            ? 'linear-gradient(135deg, #0B1220 0%, #1E3A8A 100%)'
            : 'linear-gradient(135deg, #1E3A8A 0%, #3B5BC9 100%)',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420, boxShadow: '0 20px 50px rgba(0,0,0,0.25)' }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack alignItems="center" spacing={1.5} sx={{ mb: 3 }}>
            <Box
              component="img"
              src="/img/Peak_Logo_Kobalt.png"
              alt="Peak"
              sx={{ width: 96, height: 'auto' }}
            />
            <Typography variant="h5" sx={{ fontWeight: 700 }}>Şifre Sıfırla</Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              Kayıtlı e-posta adresini gir, sıfırlama bağlantısını gönderelim.
            </Typography>
          </Stack>

          <form onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <TextField
                label="E-posta"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                required
                autoComplete="email"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EmailIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              {feedback && <Alert severity={feedback.type}>{feedback.text}</Alert>}
              <Button
                type="submit"
                variant="contained"
                size="large"
                fullWidth
                disabled={loading}
                sx={{ py: 1.25 }}
              >
                {loading ? <CircularProgress size={22} color="inherit" /> : 'Bağlantı Gönder'}
              </Button>
            </Stack>
          </form>

          <Box sx={{ textAlign: 'center', mt: 2.5 }}>
            <Link component={RouterLink} to="/login" underline="hover">
              Giriş sayfasına dön
            </Link>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ForgotPassword;
